import classes from "./ActivityEditor.module.css";
import Skeleton from "react-loading-skeleton";
import React, {useEffect, useRef, useState} from "react";
import {
    BACK_TEXT,
    DEFAULT_IMAGE_ALT,
    DELETE_TEXT, EXPAND_IMAGE_TEXT, GENERATE_ALT_TEXT,
    IMAGE_ALT_TEXT, IMG_ALT_EDITOR_EXPLAIN,
    QUESTION_TYPES,
    TEXTBOX
} from "../../utils/constants";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {UserApiCalls} from "../../apis/UserApiCalls";
import {ReactComponent as DELETE} from "../../images/trash_red.svg";
import {ReactComponent as ACCESSIBILITY} from "../../images/accessibility_icon.svg";
import {ReactComponent as RETURN} from "../../images/return_grey.svg";
import {ReactComponent as INFO} from "../../images/gray_info_icon.svg";
import {ReactComponent as ENLARGE} from "../../images/full_screen_gray.svg";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import {YuJaImageViewer} from "../../components/standardization/YuJaImageViewer";
import ClickableImageNew from "../../questions/CI/ClickableImageNew";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {delay, notifyError, getSafeURL} from "../../utils/helpers";
import {DELETE_VIDEO_ERROR} from "../../utils/toast-message-constants";
import {YuJaCIImageViewer} from "../../components/standardization/YuJaCIImageViewer";
import {useLocation} from "react-router-dom";
import {Button} from "@base-ui/react/button";

export default function ActivityEditorQuestionMediaViewer ({
                                                               draftActivity,
                                                               setDraftActivity,
                                                               shownQuestionType,
                                                               selectedQuestion,
                                                               setQuestionVideoLoading,
                                                               checkImageIsLoading,
                                                               checkVideoIsLoading,
                                                               savePoll,
                                                               disabled,
                                                               questionBankId,
                                                               setQuestions,
}) {

    const {pollKey, questions} = draftActivity;
    const {serialNo, image, imageURL, directLinkEvp, imageAlt, questionType } = selectedQuestion;
    const imageURLRef = useRef("");
    const [, getInstitution] = useLocalStorageNew(window.location.hostname, {});
    const {evpVideoApiUrl} = getInstitution();
    let location = useLocation();
    let isReleasePage = location.pathname.startsWith("/poll/share");

    const VIEW_ENUMS = {IMG: "IMG", VIDEO: "VIDEO", ACCESSIBILITY: "ACCESSIBILITY"};

    const { deleteVideo} = PollApiCalls();
    const { deleteUserVideo} = UserApiCalls();

    const [view, setView] = useState(VIEW_ENUMS.IMG);
    const [isLoading, setIsLoading] = useState(true);
    const [showViewModal, setShowViewModal] = useState(false);

    useEffect(() => {
        setShowViewModal(false);
        if (!!directLinkEvp) {
            setView(VIEW_ENUMS.VIDEO);
            setIsLoading(false);
        } else {
            setView(VIEW_ENUMS.IMG);
            if (!!imageURL && imageURL !== imageURLRef.current && !checkImageIsLoading(selectedQuestion)) {
                setIsLoading(true);
                const img = new Image();
                img.src = imageURL;
                img.onload = () => setIsLoading(false);
                img.onerror = (e) => {
                    console.error('Failed to load image ' + imageURL);
                    setIsLoading(false);
                };
                imageURLRef.current = imageURL;
            }
        }

    }, [serialNo, imageURL, directLinkEvp]);

    const handleDeleteMedia = async () => {
        if (disabled) {
            return;
        }
        if(!!selectedQuestion.directLinkEvp) {

            let directLinkEvp = selectedQuestion.directLinkEvp;
            try {
                if (selectedQuestion.directLinkEvp.includes(evpVideoApiUrl) && !isReleasePage) {
                setQuestionVideoLoading(serialNo);
                    // setVideoUploading(true);
                    if (!questionBankId) {
                        await deleteVideo(pollKey, serialNo);
                    } else {
                        await deleteUserVideo(questionBankId, serialNo);
                    }

                }


                let newQuestions = [];
                for (const q of questions) {
                    if (q.serialNo !== selectedQuestion.serialNo) {
                        newQuestions.push(q);
                        continue;
                    }

                    const updatedQuestion = {...q, directLinkEvp: "", imageURL: "", suffix: "", image: ""};
                    newQuestions.push(updatedQuestion);
                }

                if (!!savePoll) {
                    await savePoll(newQuestions);
                } else {
                    setQuestions(newQuestions);
                }
            } catch (e) {
                console.log(e);
                notifyError(DELETE_VIDEO_ERROR);
                let newQuestions = [];
                for (const q of questions) {
                    if (q.serialNo !== selectedQuestion.serialNo) {
                        newQuestions.push(q);
                        continue;
                    }
                    console.log(`directLinkEvp: ${directLinkEvp}`)
                    const updatedQuestion = {...q, directLinkEvp: directLinkEvp, imageURL: "", suffix: "", image: ""};
                    newQuestions.push(updatedQuestion);
                    setQuestions(newQuestions);
                }
            }
            return;
        }


        //clear options
        const copy = JSON.parse(JSON.stringify(draftActivity));
        let newQuestions = [];
        for (const q of questions) {
            if (q.serialNo !== selectedQuestion.serialNo) {
                newQuestions.push({...q});
                continue;
            }

            const updatedQuestion = {...q, imageURL: "", suffix: "", image: "", imageAlt: ""};
            if (selectedQuestion.questionType === QUESTION_TYPES.CI.name) {
                updatedQuestion.optionsMap = [];
                updatedQuestion.correctAnswers = [];
            }
            newQuestions.push(updatedQuestion);
        }
        copy.questions = newQuestions;
        setDraftActivity(copy);
    };

    if (checkVideoIsLoading(selectedQuestion) || checkImageIsLoading(selectedQuestion)) {
        return (
            <span style={{flexShrink: 0, width: 360, height: 210, alignSelf: "center"}}>
                <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={6}/>
            </span>
        );
    }


    if (!imageURL && !directLinkEvp) {
        return <></>;
    }

    return (
        <div className={classes.questionMediaViewerBox}>
            {isLoading &&
                <span style={{width: "100%", height: 170}}>
                    <Skeleton highlightColor="lightgrey" width="100%" height="100%"/>
                </span>
            }

            {questionType === QUESTION_TYPES.CI.name
                ? <YuJaCIImageViewer
                    showViewer={showViewModal}
                    setShowViewer={setShowViewModal}
                    onHandleClose={() => setShowViewModal(false)}
                    questions={questions}
                    selectedQuestion={selectedQuestion}
                    imageAlt={imageAlt}
                    setQuestions={(qs) => {
                        const copy = {...draftActivity};
                        copy.questions = qs;
                        setDraftActivity(copy);
                    }}
                />
                : <YuJaImageViewer
                    showViewer={showViewModal}
                    setShowViewer={setShowViewModal}
                    onHandleClose={() => setShowViewModal(false)}
                    imageURL={imageURL}
                />
            }


            {view === VIEW_ENUMS.IMG  && !isLoading &&
                <>
                    <div className={classes.questionMediaViewerWrapper}>
                        <div className={classes.questionMediaViewer}>
                            {questionType !== QUESTION_TYPES.CI.name &&
                                <img
                                    aria-label={imageAlt ? imageAlt : DEFAULT_IMAGE_ALT}
                                    src={getSafeURL(selectedQuestion.imageURL)}
                                    alt={imageAlt ? imageAlt : `Q${image} PREVIEW_TEXT`}
                                />
                            }
                            {questionType === QUESTION_TYPES.CI.name &&
                                <ClickableImageNew
                                    questions={questions}
                                    selectedQuestion={selectedQuestion}
                                    imageAlt={imageAlt}
                                    setQuestions={(qs) => {
                                        const copy = {...draftActivity};
                                        copy.questions = qs;
                                        setDraftActivity(copy);
                                    }}
                                />
                            }
                        </div>

                    </div>
                </>

            }

            {view === VIEW_ENUMS.VIDEO && !isLoading &&
                <iframe
                    allowFullScreen
                    title={"video iFrame"}
                    style={{width: "100%", height: 240, aspectRatio: "1/1", alignSelf: "center"}}
                    src={getSafeURL(directLinkEvp)}
                    onLoad={() => setTimeout(() => {
                        setIsLoading(false)
                    }, 1000)}
                />
            }

            {view === VIEW_ENUMS.ACCESSIBILITY &&
                <div
                    className={classes.questionMediaViewerWrapper}
                    style={{background: "#FFF", justifyContent: "unset", alignItems: "unset", padding: 10, gap: 6}}
                >
                    <span
                        className={classes.btn}
                        tabIndex={0}
                        onClick={() => setView(VIEW_ENUMS.IMG)}
                        title={BACK_TEXT}
                    >
                        <RETURN style={{width: 22, height: 22}}/>
                    </span>
                    <div style={{display: "flex", alignItems: "center", gap: 5}}>
                        <span className={classes.title}>{IMAGE_ALT_TEXT}</span>
                        <YuJaTooltip text={IMG_ALT_EDITOR_EXPLAIN} tooltipStyle={{maxWidth: 300}} >
                            <span className={classes.btn}>
                                <INFO />
                            </span>

                        </YuJaTooltip>

                    </div>
                    <YuJaTextBox
                        placeholder={"Describe the image here..."}
                        value={imageAlt}
                        isMultiple={true}
                        containerStyle={{flex: 1, minHeight: 30}}
                        onChange={(e) => {
                            const copy = JSON.parse(JSON.stringify(draftActivity));
                            let que = copy.questions.find(q => q.serialNo === selectedQuestion.serialNo);
                            que.imageAlt = e.target.value;
                            setDraftActivity(copy);
                        }}
                    />
                </div>
            }


            <div className={classes.questionMediaManagerBar}>
                <Button className={classes.btn} onClick={handleDeleteMedia} aria-label={DELETE_TEXT}>
                    <DELETE/>
                </Button>

                {!directLinkEvp &&
                    <>
                        <span className={classes.questionMediaManagerBarDivider}/>
                        <Button
                            className={`${classes.btn} ${view === VIEW_ENUMS.ACCESSIBILITY ? classes.active : ""}`}
                            onClick={() => setView(VIEW_ENUMS.ACCESSIBILITY)}
                            aria-label={GENERATE_ALT_TEXT}
                        >
                            <ACCESSIBILITY/>
                        </Button>

                        <span className={classes.questionMediaManagerBarDivider}/>
                        <Button
                            aria-label={EXPAND_IMAGE_TEXT}
                            className={classes.btn}
                            onClick={() => setShowViewModal(true)}
                        >
                            <ENLARGE/>
                        </Button>
                    </>
                }
            </div>
        </div>
    );
}